// extracted by mini-css-extract-plugin
export default {"root":"fTAW2B","slides":"DU96Fk","navButton":"pbLKQ3","showOnHover":"eYz3Od","hidden":"i0fmRb","absolute":"KbCI9U","arrowLeft":"Nh9uSi","arrowRight":"qNtLuc"};